import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ActivatedRoute, Router } from '@angular/router';

import { Title } from '@angular/platform-browser';
import { ProviderService as Service} from '../core/models/provider-service.model';
import { Provider } from '../core/models/provider.model';

import { ProviderService as ProviderService } from '../core/services/provider.service';
import { NewCartService } from '../core/services/new-cart.service';
import { ServiceDetailService } from '../core/services/service-detail.service';
import { Observable, Subscription } from 'rxjs';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { Article } from '../core/models/article.model';
import { ArticleService } from '../core/services/article.service';
import { map, tap } from 'rxjs/operators';

import Swiper from 'swiper';

@Component({
  selector: 'app-magazin',
  templateUrl: './magazin.page.html',
  styleUrls: ['./magazin.page.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, SharedModule, HttpClientModule],
  providers: [ ArticleService ]
})
export class MagazinPage implements OnInit {

  @ViewChild('magazinswiper') swiperRef: ElementRef | undefined;
  swiper?: Swiper;

  provider$: Observable<Provider>;
  articles$: Observable<Article[]>;


  private queryParamMapSubscription: Subscription;

  topicSlug: string | null = null;

  constructor(
    private titleService: Title,
    private providerService: ProviderService,
    private route: ActivatedRoute,
    private articleService: ArticleService,
    public newCartService: NewCartService
  ) {

    this.queryParamMapSubscription = this.route.queryParamMap.subscribe(queryParams => {
      this.topicSlug = queryParams.get('tema');

      this.articles$ = this.articleService.getArticles$( null ).pipe(
        tap ( result  => console.log( this.topicSlug )),
        map( articles => articles.filter( article => ( !this.topicSlug || article.topic.replace(/[\s-]/g, '').toLowerCase() == this.topicSlug.replace(/[\s-]/g, '').toLowerCase()  ) ) ),  //|| article.topic == this.topicSlug
        tap ( _result  =>     this.titleService.setTitle('Aktualno | dm Studio'))
      );

    });

    this.provider$ = this.providerService.getProvider$();

  }

  ngOnInit() {
    this.titleService.setTitle('Aktualno | dm Studio');
  }

  ngOnDestroy() {
    this.queryParamMapSubscription.unsubscribe();
  }

  getImageUrl(id) {

    if (id === 1) {
      return 'https://docs.api.pricepilot.io/655b2a9f21e76.jpeg';
    }

    if (id === 3) {
      return 'https://docs.api.pricepilot.io/655b1d3703b36.jpeg';
    }

    if (id === 4) {
      return 'https://docs.api.pricepilot.io/655b1be684ca8.jpeg';
    }

    return 'https://docs.api.pricepilot.io/652dadba274e4.jpeg';

  }

}
